import { createPerformanceObserver } from 'owa-analytics/lib/utils/factory';
import { getBootTimings } from 'owa-performance/lib/utils/trackBootTimings';
import { getTimeFromFetchStart } from 'mini-performance/lib/utils/getTimeFromFetchStart';
import { getTiming } from 'mini-performance/lib/utils/measureFunctionPerf';

/**
 * List of resources to track
 */
const RESOURCES_TO_TRACK = {
    sessiondata: 'sd',
    startupdata: 'sd',
    // For both sessiondata and startupdata, the key is sd for aria dashboard plots
    // And for a session, it will be either sessiondata or startup depending on the flighting
    userbootsettings: 'ubs',
    FindPeople: 'fp',
    'owa.MailBoot.js': 'mbjs',
    'owa.CalendarBoot.js': 'cbjs',
    'owa.PeopleBoot.js': 'pbjs',
    'owa.MiniOpxDeepLinkBoot.js': 'mdlbjs',
};

/**
 * Private function which checks if the given resource is listed in tracked resource.
 * @param resourceName Name of the resource
 */
function getResourceTracked(resourceName: string) {
    const resourceKeys = Object.keys(RESOURCES_TO_TRACK);
    for (const key of resourceKeys) {
        if (resourceName.indexOf(key) !== -1) {
            return RESOURCES_TO_TRACK[key];
        }
    }
    return false;
}

const payloadData: any = {};
let observer = null;

/**
 * This function initiates tracking of navigation timing data of the requires resources
 */
export function trackCriticalBootTimingData() {
    try {
        const entryType = 'resource';

        // Register the Perf observer
        observer = createPerformanceObserver(entryType, list => {
            const entries = list.getEntries();
            for (let index = 0; index < entries.length; index++) {
                const name = entries[index].name;
                const entry = entries[index] as PerformanceResourceTiming;
                const result = getResourceTracked(name);
                if (result) {
                    payloadData[result] =
                        getTimeFromFetchStart(Math.round(entry.requestStart)) +
                        '_' +
                        getTimeFromFetchStart(Math.round(entry.responseStart)) +
                        '_' +
                        getTimeFromFetchStart(Math.round(entry.responseEnd));
                }
            }
        });
        observer ? observer.observe({ buffered: true, type: entryType }) : null;
    } catch (error) {}
}

/**
 * This function stops the tracking and returns the accumulated data for the tracked resources
 */
export function getCriticalTimingData() {
    observer && observer.disconnect();

    try {
        const bootTimings = JSON.parse(getBootTimings());
        /* tslint:disable:no-string-literal */
        payloadData['bt_sd'] =
            getTimeFromFetchStart(bootTimings['sd_s']) +
            '_' +
            getTimeFromFetchStart(bootTimings['sd_e']);
        payloadData['bt_ubs'] =
            getTimeFromFetchStart(bootTimings['ubs_s']) +
            '_' +
            getTimeFromFetchStart(bootTimings['ubs_e']);
        payloadData['bt_btsp'] =
            getTimeFromFetchStart(bootTimings['btsp_s']) +
            '_' +
            getTimeFromFetchStart(bootTimings['btsp_e']);
        payloadData['in_e'] = bootTimings['in_e'];
        payloadData['bt_ren'] =
            getTimeFromFetchStart(bootTimings['ren_s']) +
            '_' +
            getTimeFromFetchStart(bootTimings['ren_e']);
        payloadData['loc'] = Math.floor(getTiming('localization'));

        if (getTiming('early_fp')) {
            payloadData['early_fp'] = Math.floor(getTiming('early_fp'));
        }

        if (getTiming('earlyprocessing')) {
            payloadData['ep'] =
                getTimeFromFetchStart(Math.floor(getTiming('earlyprocessing_s'))) +
                '_' +
                getTimeFromFetchStart(Math.floor(getTiming('earlyprocessing_e')));
        }

        if (getTiming('earlyCalEventsFetch')) {
            payloadData['early_ce'] =
                getTimeFromFetchStart(Math.floor(getTiming('earlyCalEventsFetch_s'))) +
                '_' +
                getTimeFromFetchStart(Math.floor(getTiming('earlyCalEventsFetch_e')));
        }

        /* tslint:enable:no-string-literal */
    } catch (error) {}

    return payloadData;
}
